import type { IconName } from '@wl/ui';
import type { ComponentType } from 'react';

export interface AdminModule {
  path: string;
  label: string;
  icon: IconName;
  section: 'main' | 'catalog' | 'security';
  load: () => Promise<{ default: ComponentType }>;
  nav?: boolean;
  mobileTab?: number;
  end?: boolean;
}

export const SECTION_TITLES = { main: undefined, catalog: 'Katalog', security: 'Güvenlik' } as const;

/** Platform panelinin tüm sayfaları (rota + menü). */
export const MODULES: AdminModule[] = [
  { path: '/', label: 'Genel bakış', icon: 'home', section: 'main', end: true, mobileTab: 1, load: () => import('../pages/dashboard/DashboardPage') },
  { path: '/tenants', label: 'Tenantlar', icon: 'building', section: 'main', mobileTab: 2, load: () => import('../pages/tenants/TenantsPage') },
  { path: '/tenants/:id', label: 'Tenant', icon: 'building', section: 'main', nav: false, load: () => import('../pages/tenants/TenantDetailPage') },
  { path: '/tenants/:tenantId/users/:userId', label: 'Kullanıcı', icon: 'user', section: 'main', nav: false, load: () => import('../pages/tenants/TenantUserPage') },
  { path: '/tenants/:tenantId/bulk-orders/new', label: 'Yeni toplu emir', icon: 'layers', section: 'main', nav: false, load: () => import('../pages/bulk-orders/BulkOrderTicketPage') },
  { path: '/tenants/:tenantId/bulk-orders/:id', label: 'Toplu emir', icon: 'layers', section: 'main', nav: false, load: () => import('../pages/bulk-orders/BulkOrderDetailPage') },
  { path: '/controls', label: 'Bakım ve kontroller', icon: 'pause', section: 'main', mobileTab: 3, load: () => import('../pages/controls/ControlsPage') },
  { path: '/bulk-orders', label: 'Toplu emirler', icon: 'layers', section: 'main', load: () => import('../pages/bulk-orders/BulkOrdersMonitorPage') },
  { path: '/brokers', label: 'Kurumlar', icon: 'briefcase', section: 'catalog', load: () => import('../pages/brokers/BrokersPage') },
  { path: '/stocks', label: 'Hisseler', icon: 'candle', section: 'catalog', load: () => import('../pages/stocks/StocksPage') },
  { path: '/auto-trade', label: 'Strateji ve indikatör', icon: 'bot', section: 'catalog', load: () => import('../pages/auto-trade/AutoTradePage') },
  { path: '/auto-trade/strategies/:id', label: 'Strateji', icon: 'bot', section: 'catalog', nav: false, load: () => import('../pages/auto-trade/StrategyDetailPage') },
  { path: '/signals', label: 'Sinyaller', icon: 'zap', section: 'catalog', load: () => import('../pages/auto-trade/SignalsPage') },
  { path: '/security', label: 'Giriş ve denetim kayıtları', icon: 'activity', section: 'security', mobileTab: 4, load: () => import('../pages/security/SecurityPage') },
  { path: '/admins', label: 'Yöneticiler', icon: 'shield', section: 'security', load: () => import('../pages/admins/AdminsPage') },
];
